import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import Button, {ButtonVariant} from 'components/Button';
import {Separator} from "./Constructor";

const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 10px;
`;

const FooterText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;
  text-align: left;
  white-space: pre-wrap;
  color: ${({theme}) => transparentize(.6, theme.variables.color)};
`;

const FooterLink = styled(FooterText)`
  display: inline;
  margin: 0 5px;
  cursor: pointer;
  color: ${({theme}) => theme.colors.primaryLight};
`;

/**
 * render tariffs Footer component
 * @constructor
 */
export default function Footer(): React.ReactElement {
  return (
    <React.Fragment>
      <Buttons>
        <Button type={'submit'} variant={ButtonVariant.Primary}>
          Оплатить
        </Button>
        <Button variant={ButtonVariant.Outline}>
          Оплатить по реквизитам
        </Button>
      </Buttons>
      <FooterText>
        Нажимая кнопку, Вы соглашаетесь с
        <FooterLink>Условиями пользовательского соглашения</FooterLink>
        {'\n'}
        и подтверждаете, что ознакомлены и согласны с
        <FooterLink>Политикой конфиденциальности</FooterLink>
        сайта grow-place.com

        <Separator />

        Оплата онлайн осуществляется через CloudPayments
        с любой банковской карты MASTERCARD, VISA, МИР,
        {'\n'}
        а также возможно оплатить
        с помощью Apple Pay и Google Pay.
      </FooterText>
    </React.Fragment>
  );
}
